import React, { Component, Suspense } from 'react';
import Cripto from '../utils/cripto'
import { Switch, Route } from 'react-router-dom';
import Loadable from 'react-loadable';

import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import '../../node_modules/font-awesome/scss/font-awesome.scss';
import firebase from '../config/firebase';
import Loader from './layout/Loader'
import Aux from "../hoc/_Aux";
import ScrollToTop from './layout/ScrollToTop';
import routes from "../route";

import { useSelector } from 'react-redux'

import {
    userPerfilToken,
    userObservableToken
} from '../actions'


firebase.auth().setPersistence("local");
const AdminLayout = Loadable({
    loader: () => import('./layout/AdminLayout'),
    loading: Loader
});
 
class App extends Component {

    verificarLogin() {
        if(this.props.token != null ){
            if(this.props.token != Cripto.DecryptedStorage('token') && this.props.token != ''){
                if(Cripto.DecryptedStorage('token') != this.props.token){
                    window.location.assign('/login');
                    return;
                }
            }
        }
        

        if(Cripto.DecryptedStorage('logado') === 'true'){
            if (Cripto.DecryptedStorage('perfil') === undefined || Cripto.DecryptedStorage('perfil') == null || Cripto.DecryptedStorage('perfil') === '')
                window.location.assign('/login');
                return;
        }else{
            window.location.assign('/login');
            return;
        }
    }

    render() {
      
        const menu = routes.map((route, index) => {
          return (route.component) ? (
              <Route
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  render={props => (
                      <route.component {...props} />
                  )} />
          ) : (null);
        });

        return (
            <Aux>
                <ScrollToTop>
                    <Suspense fallback={<Loader/>}>
                        <Switch>
                            {menu}
                            <Route path="/" component={AdminLayout} />
                        </Switch>
                    </Suspense>
                </ScrollToTop>
            </Aux>
        );
    }
}
export default App
